import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { packages } from "@/data/services";

const Packages = () => (
  <PageLayout>
    <Seo
      title="Property Upgrade Packages Melbourne – Oz Property Services"
      description="Bundle multiple property services together for a cleaner result and better value across Melbourne homes, rentals and businesses."
      path="/packages"
    />
    <PageHero
      title="High-Value Property Upgrade Packages"
      subtitle="Bundle multiple services together for a cleaner result and better value."
    />
    <section className="bg-white py-16 md:py-24">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8">
          {packages.map((p) => (
            <div key={p.title} className="bg-card rounded-2xl p-8 flex flex-col">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center shrink-0">
                  <p.icon className="w-6 h-6 text-dark" />
                </div>
                <h2 className="text-2xl font-black text-dark">{p.title}</h2>
              </div>
              <p className="text-muted-foreground leading-relaxed mb-6">{p.desc}</p>

              <div className="mb-5">
                <p className="font-bold text-dark text-sm mb-2">What's included</p>
                <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2">
                  {p.includes.map((i) => (
                    <li key={i} className="flex gap-2.5 text-dark/80 text-sm">
                      <span className="text-yellow font-black">›</span>
                      {i}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mb-6">
                <p className="font-bold text-dark text-sm mb-2">Optional add-ons</p>
                <ul className="flex flex-wrap gap-2">
                  {p.addons.map((a) => (
                    <li key={a} className="text-xs font-semibold text-dark/70 bg-yellow/15 rounded-full px-3 py-1">
                      {a}
                    </li>
                  ))}
                </ul>
              </div>

              <Link
                to="/get-quote"
                className="mt-auto inline-block text-center bg-[#1a1a1a] text-[#FFC300] px-6 py-3 font-bold rounded-md hover:opacity-90 transition-opacity"
              >
                Request a Quote
              </Link>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-12 max-w-2xl mx-auto">
          Licensed trades can be coordinated where required.
        </p>
      </div>
    </section>
  </PageLayout>
);

export default Packages;
